import { keymap } from "prosemirror-keymap";
import { addListNodes, liftListItem, sinkListItem, } from "prosemirror-schema-list";
import { Extension } from "../../core/extension";
import { toggleListNode } from "../../commands/commands";
export class ListExtension extends Extension {
    addNodes(nodes) {
        return addListNodes(nodes, "paragraph block*", "block");
    }
    addPlugins(schema, plugins) {
        return plugins.concat([
            keymap({
                Tab: sinkListItem(schema.nodes.list_item),
                "Shift-Tab": liftListItem(schema.nodes.list_item),
            }),
        ]);
    }
    addCommands(schema) {
        return {
            toggleBulletedList: toggleListNode(schema.nodes.bullet_list, schema.nodes.list_item),
            toggleNumberedList: toggleListNode(schema.nodes.ordered_list, schema.nodes.list_item),
        };
    }
}
